import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ pageTitle, breadcrumbs }:any) => {
  return (
    <div className="page-breadcrumb">
      <div className="row">
        {/* <div className="col-2 align-self-center">
          <h5 className="page-title">{pageTitle}</h5>
        </div> */}
        <div className="col-9 align-self-center">
          <div className="d-flex align-items-center justify-content-start">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb" style={{color:"#0555c8"}}>
                {breadcrumbs.map((breadcrumb:any, index:any) => (
                  <li
                    key={index}
                    className={`breadcrumb-item ${breadcrumb.isActive ? 'active' : ''}`}
                    aria-current={breadcrumb.isActive ? 'page' : undefined}
                  >
                    {breadcrumb.isActive ? (
                      breadcrumb.label
                    ) : (
                      <Link to={breadcrumb.path}>{breadcrumb.label}</Link>
                    )}
                  </li>
                ))}
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
